<template>
  <v-app id="unr-registration">
    <v-main>
      <distributor v-if="isStepDistributor"></distributor>
      <registration v-if="isStepRegistration"></registration>
    </v-main>
    <notifications group="foo"></notifications>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import Distributor from '@/features/registration/components/distributor';
import Registration from '@/features/registration/components/registration';

export default {
  name: 'PageRegistration',
  components: {
    Distributor,
    Registration,
  },
  computed: mapGetters([
    'isStepDistributor',
    'isStepRegistration',
  ]),
};
</script>
